import { GenericError as genericErrorMapping } from 'sigma-mappings';
import { isValidationError, getValidationErrors } from './validationErrors';
import getMessage from './getMessage';

export const DEFAULT_GENERIC_ERROR_MESSAGE = Object.seal({
  code: 'ME015',
});

export const DEFAULT_403_FORBIDDEN = Object.seal({
  code: 'ME061',
});

/**
 * Obtem as mensagems a partir dos dados da resposta.
 * @param {Object} mainErrorData Objeto de dados da resposta de erro.
 * @param {Object} [messageParams] Parâmetros para formatar a mensagem de erro.
 * @returns {Array} Array de mensagens contidas nos dados.
 */
export function getMessagesFromResponseData(mainErrorData, messageParams) {
  const messages = [];
  if (isValidationError(mainErrorData)) {
    messages.push(...getValidationErrors(mainErrorData, messageParams));
  } else {
    const message = getMessage(mainErrorData, messageParams);
    if (message) {
      messages.push(message);
    }
  }
  return messages;
}

/**
 * Retorna todas as mensagens contídas no erro. Se não houver nenhuma mensagem conhecida,
 * retorna uma mensagem de erro genérica.
 * @param {Object} errorResult Erro de requisição emitido pelo Axios.
 * @param {Object|Function} [messageParams] Parametros para formatação da mensagem.
 * @param {Function} [errorDataSelector] Função que filtra o erro, extraindo o objeto de
 * erro da API de dentro dos dados da requisição.
 * @returns {Array} Array de mensagens contidas nos dados ou mensagem de erro desconhecido.
 */
export function getMessagesFromResponseError(errorResult, messageParams, errorDataSelector) {
  const messages = [];

  const apiErrorData = errorDataSelector
    ? errorDataSelector(errorResult)
    : (errorResult.response?.data);

  const errorData = genericErrorMapping(apiErrorData);

  if (errorData) {
    if (typeof messageParams === 'function') {
      // eslint-disable-next-line no-param-reassign
      messageParams = messageParams(errorResult, errorData);
    }

    const responseMessages = getMessagesFromResponseData(
      errorData,
      messageParams,
    );
    messages.unshift(...responseMessages);
  }

  if (messages.length === 0 && errorResult.response?.status === 403) {
    messages.push(DEFAULT_403_FORBIDDEN);
  }

  if (messages.length === 0) {
    messages.push(DEFAULT_GENERIC_ERROR_MESSAGE);
  }

  return messages;
}

function mapXhrRequestResponseToErrorMessageResponse({ responseText }) {
  return {
    messageCode: responseText,
  };
}

export function getMessagesFromTusResponseError({ originalRequest: xhrRequest }, messageParams) {
  const errorResponse = mapXhrRequestResponseToErrorMessageResponse(xhrRequest);
  const errorMessage = getMessage(errorResponse, messageParams);
  return [errorMessage || DEFAULT_GENERIC_ERROR_MESSAGE];
}
